export default "__VITE_ASSET__CckkVHyy__"